import React from "react";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";

const Dish = ({ dish }) => {
  //pass Delta content into QuillDeltaToHTMLConverter() 
  const converter = new QuillDeltaToHtmlConverter(dish.content.ops, {});
  //call .convert()
  const contentHTML = converter.convert();

  return (
    <article className="container main--content main--content--article">

      <div className="article--img--contain mt-4">
          <img className="d-block article--img img-fluid mx-auto text-center" alt={dish.title} src={dish.imgUrl || "https://placeimg.com/640/480/nature"}  />
      </div>
      <h1 className="text-center mt-4">{dish.title}</h1>
      <p className="text-center" >Posted: {dish.date}</p>

        {
          //to display HTML from a variable into a React app need to use a special property dangerouslySetInnerHTML
        }
      <div
        className="content"
        dangerouslySetInnerHTML={{ __html: contentHTML }}
      />
      {
          //display image that was added by user
          //<img src={dish.uploadedFileCloudinaryUrl} />
      }
      
    </article>
  );
};

export default Dish;
